export const BATCH_LIST_REQUEST = 'BATCH_LIST_REQUEST';
export const BATCH_LIST_SUCCESS = 'BATCH_LIST_SUCCESS';
export const BATCH_LIST_FAIL = 'BATCH_LIST_FAIL';
export const BATCH_LIST_RESET = 'BATCH_LIST_RESET';
export const BATCH_LIST_REMOVE_ITEM = 'BATCH_LIST_REMOVE_ITEM';

export const BATCH_DETAILS_REQUEST = 'BATCH_DETAILS_REQUEST';
export const BATCH_DETAILS_SUCCESS = 'BATCH_DETAILS_SUCCESS';
export const BATCH_DETAILS_FAIL = 'BATCH_DETAILS_FAIL';
export const BATCH_DETAILS_RESET = 'BATCH_DETAILS_RESET';

export const BATCH_EDIT_REQUEST = 'BATCH_EDIT_REQUEST';
export const BATCH_EDIT_SUCCESS = 'BATCH_EDIT_SUCCESS';
export const BATCH_EDIT_FAIL = 'BATCH_EDIT_FAIL';
export const BATCH_EDIT_RESET = 'BATCH_EDIT_RESET';

export const BATCH_ADD_REQUEST = 'BATCH_ADD_REQUEST';
export const BATCH_ADD_SUCCESS = 'BATCH_ADD_SUCCESS';
export const BATCH_ADD_FAIL = 'BATCH_ADD_FAIL';
export const BATCH_ADD_RESET = 'BATCH_ADD_RESET';

export const BATCH_DELETE_REQUEST = 'BATCH_DELETE_REQUEST';
export const BATCH_DELETE_SUCCESS = 'BATCH_DELETE_SUCCESS';
export const BATCH_DELETE_FAIL = 'BATCH_DELETE_FAIL';
export const BATCH_DELETE_RESET = 'BATCH_DELETE_RESET';
